import { AssistantRuntimeProvider, useLocalRuntime } from '@assistant-ui/react';
import { Thread } from '@components/assistant-ui/thread';
import { createCustomModelAdapter } from '@services/assitantRuntime';
import toast from '@services/toast.service';
import { FC, useCallback, useState } from 'react';
import "@assistant-ui/styles/index.css";
import "@assistant-ui/styles/markdown.css";
import pliableLogo from '@assets/images/pliable/logo_with_text_black.png';
import { useHotkeys } from 'react-hotkeys-hook';

import { makeAssistantToolUI } from '@assistant-ui/react';

const CalendlyTool = makeAssistantToolUI<{ prompt: string }, { message: string, status: string }>({
  toolName: 'schedule_onboarding_call',
  render: ({ args, result, addResult }) => {
    if (result) {
      console.log(result.message as string);
      return (
        <div className="rounded bg-green-50 p-3">
          ✅ {result.message}
        </div>
      );
    }
    return (
      <div className="rounded border p-4">
        <p className="mb-3"></p>
        <h1>hello</h1>
        <button className="btn btn-pliable"
          onClick={() => {
            addResult({status: 'complete', message:'Onboarding scheduled for 2025-09-15'});
          }}
          >go</button>
      </div>
    );
  }
});

const OnboardringWelcome: FC = () => {
  return (
    <div className="aui-thread-welcome-root">
      <div className="aui-thread-welcome">
          <p className="aui-thread-welcome-message">
          <img src={pliableLogo} style={{width: '200px'}} className="mb-5"/>

          <h2>Welcome to Pliable,</h2>
            Pliable is a low-code data cleaning and modeling tool that helps you get your data organized for analytics and AI. 
            <br /><br />
            Can you share more about what you're trying to accomplish today?</p>
        </div>
    </div>
  );
};

interface AiOnboarderProps {
    // show: boolean;
    onHide?: () => any;
}

const AiOnboarder = (props: AiOnboarderProps) => {
    const modelAdapter = createCustomModelAdapter({agent_type: 'onboarding'});
    const runtime = useLocalRuntime(modelAdapter);

    // Add explicit type annotation to help TypeScript
    const typedRuntime = runtime as any; // Type assertion to resolve type issues

    useHotkeys('esc', () => {
        if(props.onHide) {
            props.onHide();
        }
    }, []);
    
        
    typedRuntime.thread.subscribe(() => {
        const msgs = typedRuntime.thread.getState().messages;
        console.log('Messages updated:', msgs);
    });

    return (

        <>  
            <AssistantRuntimeProvider runtime={typedRuntime}>
                <CalendlyTool />
                <Thread WelcomeComponent={OnboardringWelcome} />
            </AssistantRuntimeProvider>
        </>
        
    );
}

export default AiOnboarder